
<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Consultoria"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <consultoria-form-atualizar
            operacao="A"
            :consultoria="consultoria"
            :acao="acao"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></consultoria-form-atualizar>
    </div>
</template>

<script>
import ConsultoriaFormAtualizar from './ConsultoriaFormAtualizar'

export default {
    components: {
        ConsultoriaFormAtualizar
    },

    props: {
        consultoria: {
            type: Object,
            default: () => {}
        },
        acao: {
            type: Object,
            default: () => ({})
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(consultoria) {
            
            this.$store.dispatch('addRequest')

            let consultoriaDto ={};

            consultoriaDto = consultoria;

            consultoriaDto = {
                nomeConsultoria: consultoria.nomeConsultoria,
                totalPrevisto: consultoria.totalPrevisto,
                totalRealizado: consultoria.totalRealizado,
                idConsultoria:consultoria.idConsultoria,
                idAcaoPlanoTrabalho: consultoria.idAcaoPlanoTrabalho
            }
           

            this.dataServicos.alterarConsultoria(consultoriaDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Consultoria atualizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.$emit('atualizarErros', response.errors);
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
        
            
    },
}
</script>
